// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3859": "e5ac1b0c","5545": "20927b2f","7869": "22f405b2","8357": "dd422574",}[chunkId] + ".css"
}